import { slackTrelloDomain, slackTrelloMicrosDomain } from '@trello/config';
import { fetchWithTimeout } from './fetchWithTimeout';
import { featureFlagClient } from '@trello/feature-flag-client';
import { Analytics } from '@trello/atlassian-analytics';

export const getSlackUsers = async (searchQuery: string, cookie: string) => {
  const queryParams = new URLSearchParams({
    q: searchQuery,
  });
  const isSlackTrelloOnMicros = featureFlagClient.get(
    'product-integrations.trello-slack-micros',
    false,
  );
  const slackTrelloBaseUrl = isSlackTrelloOnMicros
    ? slackTrelloMicrosDomain
    : slackTrelloDomain;
  const res = await fetchWithTimeout(
    `${slackTrelloBaseUrl}/members/search?${queryParams}`,
    cookie,
    {
      timeout: 5000,
    },
  );
  if (res?.ok) {
    Analytics.sendTrackEvent({
      action: 'succeeded',
      actionSubject: 'fetchSlackUsers',
      source: 'inviteToBoardInlineDialog',
      attributes: {
        growthInitiative: 'inviteFromSlack',
      },
    });
    return res?.json();
  } else {
    throw res;
  }
};
